import React, { useState } from "react";
import { Modal, Box, FormGroup, FormControlLabel, Checkbox, Stack } from "@mui/material";
import { ModalWrapper, StyledBackdrop } from "../../../ProductOrder/single/AddProductModal/Styled";
import { TitleText } from "../../../MaterialOrder/single/AddMaterialModal/Styled";
import DateRangeFilter from "../../../../shared/components/FilterOption/DateRangeFilter";
import { ButtonWrapper } from "../../../../shared/components/CancelModal/Styled";
import LoadingButton from "../../../../shared/components/LoadingButton";

interface ExportMaterialQuantitySummaryModalProps { 
    open: boolean;
    handleClose: () => void;
    handleConfirm: (selectedTypes: string[], dateRange: [string | null, string | null]) => Promise<void>;     
    isLoading?: boolean;
}

const ExportMaterialQuantitySummaryModal = ({ open, handleClose, handleConfirm, isLoading }: ExportMaterialQuantitySummaryModalProps) => {
    const [isOpen, setIsOpen] = useState(open);
    const [dateRange, setDateRange] = useState<[string | null, string | null]>([null, null]);
    const [selectedTypes, setSelectedTypes] = useState<string[]>([]);

    const REPORT_OPTIONS = [
        "Báo cáo nhập xuất tồn",
        "Báo cáo chi tiết xuất",
        "Báo cáo chi tiết nhập",
    ];

    const handleCloseWithAnimation = () => {
        setIsOpen(false);
        setTimeout(handleClose, 200);
    };

    const handleDateRangeChange = (value: [string | null, string | null]) => {
        setDateRange(value);
    };

    const handleConfirmWithAnimation = () => {
        handleConfirm(selectedTypes, dateRange);
        setTimeout(handleClose, 100);
    };

    return (
        <Modal open={open}
        onClose={handleCloseWithAnimation}
        closeAfterTransition
        BackdropComponent={StyledBackdrop}
        BackdropProps={{
            timeout: 500,
            onClick: (e) => e.stopPropagation(),
        }}>
            <ModalWrapper isOpen={isOpen} style={{width: "28vw"}}> 
                <TitleText>Chọn loại báo cáo để xuất</TitleText>
                <Box sx={{ p: 2 }}>
                    <Stack spacing={2}>
                    <FormGroup>
                        {REPORT_OPTIONS.map((option) => (
                            <FormControlLabel
                                key={option}
                                control={
                                    <Checkbox
                                        checked={selectedTypes.includes(option)}
                                        onChange={(e) => {
                                            const checked = e.target.checked;
                                            setSelectedTypes((prev) =>
                                                checked
                                                    ? Array.from(new Set([...prev, option]))
                                                    : prev.filter((v) => v !== option)
                                            );
                                        }}
                                    />
                                }
                                label={option}
                            />
                        ))}
                    </FormGroup>
                    <DateRangeFilter
                        onChangeValue={handleDateRangeChange}
                            isReset={false}
                        />
                    </Stack>
                </Box>

                <ButtonWrapper style={{ justifyContent: "flex-end" }}>
                    <LoadingButton
                        variant="outlined"
                        onClick={handleCloseWithAnimation}
                        isLoading={false}
                        style={{
                            paddingTop: 8,
                            paddingBottom: 8,
                            display: "flex",
                            justifyContent: "center",
                            width: "60%",
                            minWidth: "120px",
                        }}
                        text={"Đóng"}
                    />
                    <LoadingButton
                        variant="contained"
                        onClick={handleConfirmWithAnimation}
                        disabled={selectedTypes.length === 0 || dateRange[0] === null || dateRange[1] === null || isLoading}
                        isLoading={isLoading}
                        style={{
                            paddingTop: 8,
                            paddingBottom: 8,
                            display: "flex",
                            justifyContent: "center",
                            width: "60%",
                            minWidth: "120px",
                        }}
                        text={"Xuất báo cáo"}
                    />
                </ButtonWrapper>
            </ModalWrapper>
        </Modal>
    );
};

export default ExportMaterialQuantitySummaryModal; 